import React from 'react';
import {Button} from "@xpertdox_js/xdcomponents";
import TsDsDisplay from '../../../TrialOverview/Panels/Filters/TsDsDisplay';
import styles from '../subComponentStyles';

const EditedLogs = (props) => {
    let items = [];
    if(props.data) items = props.data.sort((a,b) => new Date(b.timestamp) - new Date(a.timestamp))
    const revert = (value) => {
        let id = props.settings[0].id;
        props.state.setFormState({[id]: value});
        if(props.customProps) {
            if(props.customProps.type === 'inc') props.customProps.incState.setter(value)
            if(props.customProps.type === 'exc') props.customProps.excState.setter(value)
        }
        props.submit({value})
    }

    const Content = ({index, data}) => {
        let display = '';
        if(Array.isArray(data.value)) display = data.value.length > 0 ? data.value.join(', ') : 'N/A';
        else if(typeof data.value === 'string') display = data.value === '' ? 'N/A' : data.value;
        else if(typeof data.value === 'object' && data.value !== null) display = <TsDsDisplay
            {...props.customProps}
            incState={{...props.customProps.incState, value: data.value}}
            excState={{...props.customProps.excState, value: data.value}}
            data={data.value}
        />
        return <div>
            <div style={styles.list.item}>
                <Button onClick={() => revert(data.value)} styles={styles.list.btn}>Revert</Button>
                <p style={styles.list.text}>{display}</p>
                <div style={styles.list.sub}>
                    <p style={styles.list.text}>{data.user.email}</p>
                    <p style={styles.list.text}>{data.timestamp}</p>
                </div>
            </div>
        </div>
    }

    return <div style={styles.container}>
        <h4 style={styles.heading}>Edited Logs</h4>
        {items.map((d, i) => <Content key={i} data={d}/>)}
    </div>
}

export default EditedLogs;